<!-- Form row -->
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <form (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm" novalidate>


                    <!-- DOS FILAS INCICIALES -->
                    <div class="row">

                        <!-- Columna para el avatar -->
                        <div class="col-md-2 d-flex flex-column align-items-center">
                            <img *ngIf="avatarUrl" [src]="avatarUrl" class="rounded-circle"
                                style="width: 130px; height: 130px; object-fit: cover;">

                            <!-- El input de archivo está oculto -->
                            <input type="file" id="inputAvatar" (change)="onFileChange($event)" name="avatar"
                                style="display: none;">

                            <!-- Botón que el usuario hace clic para cambiar la foto -->
                            <button class="btn btn-primary mt-3 mb-3" (click)="triggerFileInput()" type="button"><span
                                    i18n>Cambiar mi foto</span></button>
                        </div>

                        <!-- Columnas para los campos, organizados en dos filas -->
                        <div class="col-md-10">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="inputApellidos" class="form-label" i18n>Apellidos</label>
                                    <input type="text" class="form-control" id="inputApellidos"
                                        i18n-placeholder="@@apellidosPlaceholder" placeholder="Apellidos"
                                        name="apellidos" #apellidos="ngModel" [(ngModel)]="usuario.apellidos" required
                                        [ngClass]="{ 'is-invalid': (apellidos.invalid && f.submitted) || (apellidos.invalid && (apellidos.dirty || apellidos.touched))}">
                                    <div
                                        *ngIf="(apellidos.invalid && f.submitted) || (apellidos.invalid && (apellidos.dirty || apellidos.touched))">
                                        <p class="validator-message" i18n>Campo obligatorio</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label for="inputNombre" class="form-label" i18n>Nombre</label>
                                    <input type="text" class="form-control" id="inputNombre"
                                        i18n-placeholder="@@nombrePlaceholder" placeholder="Nombre" name="nombre"
                                        #nombre="ngModel" [(ngModel)]="usuario.nombre" required
                                        [ngClass]="{ 'is-invalid': (nombre.invalid && f.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))}">
                                    <div
                                        *ngIf="(nombre.invalid && f.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))">
                                        <p class="validator-message" i18n>Campo obligatorio</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-3 mb-3">
                                    <label for="inputState" class="form-label" i18n>Tipo de usuario</label>

                                    <!-- Si es representante, muestra el campo en modo solo lectura -->
                                    <input *ngIf="usuario.es_representante" type="text" class="form-control"
                                        id="inputState" value="REPRESENTANTE" readonly>

                                    <!-- Si no es representante, permite elegir el nivel de acceso (solo ADMIN) -->
                                    <select *ngIf="!usuario.es_representante" id="inputState" class="form-select"
                                        name="nivel_acceso" [(ngModel)]="usuario.nivel_acceso" required>
                                        <option value="ADMIN" i18n>ADMIN</option>
                                    </select>

                                    <!-- Validación de errores -->
                                    <div
                                        *ngIf="(f.submitted && usuario.nivel_acceso === '') || (f.submitted && !usuario.nivel_acceso)">
                                        <p class="validator-message" i18n>Campo obligatorio</p>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3">
                                    <label for="inputTelefono" class="form-label" i18n>Teléfono</label>
                                    <input type="text" class="form-control" id="inputTelefono"
                                        i18n-placeholder="@@telefonoPlaceholder" placeholder="Teléfono" name="telefono"
                                        #telefono="ngModel" [(ngModel)]="usuario.telefono" required
                                        [ngClass]="{ 'is-invalid': (telefono.invalid && f.submitted) || (telefono.invalid && (email.dirty || telefono.touched))}">
                                    <div
                                        *ngIf="(telefono.invalid && f.submitted) || (telefono.invalid && (telefono.dirty || telefono.touched))">
                                        <p class="validator-message" i18n>Campo obligatorio</p>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="inputEmail" class="form-label" i18n>Email</label>
                                    <input type="email" class="form-control" id="inputEmail"
                                        i18n-placeholder="@@emailPlaceholder" placeholder="Email" name="email"
                                        #email="ngModel" [(ngModel)]="usuario.email" required
                                        [ngClass]="{ 'is-invalid': (email.invalid && f.submitted) || (email.invalid && (email.dirty || email.touched))}">
                                    <div
                                        *ngIf="(email.invalid && f.submitted) || (email.invalid && (email.dirty || email.touched))">
                                        <p class="validator-message" i18n>Campo obligatorio</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- FIN DOS FILAS INCICIALES -->


                    <div class="text-md-end">
                        <button type="submit" class="btn btn-primary waves-effect waves-light"><span
                                i18n>Guardar</span></button>
                    </div>

                </form>

            </div> <!-- end card-body -->
        </div> <!-- end card-->
    </div> <!-- end col -->
</div>
<!-- end row -->